/* eslint-disable @typescript-eslint/no-unused-vars */
import React from 'react';
import './Dashboard.css';
import 'react-grid-layout/css/styles.css';
import 'react-resizable/css/styles.css';
import PowerBiReport from '../components/PowerBiReport'
import { PowerBiReportType } from '../services/powerBiApi';


const Dashboards: React.FC = () => {

  return (
      <div className="dashboard-container">
          <PowerBiReport reportType={PowerBiReportType.Main} />
    </div>
  );
};


export default Dashboards; 